import { Shipwreck, _html } from 'shipwreck/src/shipwreck.js';
import marked from 'marked';
import config from '../config/config.js';

marked.setOptions({
  breaks: true,
})

let currentPath = '/';

// notifications
const flash = {
  box: document.getElementById('flash'),
  clear: () => flash.box.innerHTML = '',
  add: (msg, type) => flash.box.appendChild(_html(`<div class="banner ${type}">${msg}</div>`)),
};

// handles to key elements
const shipOutput = document.getElementById('ship-output');
const loadingBar = document.getElementById('loading-bar');
const profileContent = document.getElementById('profile-content');

// create shipwreck instance
const ship = new Shipwreck(shipOutput);

ship.baseUri = config.api.href || 'https://dev-api.binsentry.com';

ship.on('fetch', () => {
  loadingBar.style.backgroundColor = 'var(--purple-base)';
  loadingBar.style.width = '10%';
  flash.clear();
});

ship.on('error', async function(e) {
  loadingBar.style.backgroundColor = 'var(--red-base)';
  loadingBar.style.width = '100%';
  const { message, response } = e.detail;
  flash.add(message, 'critical');
  if (response) {
    const contentType = response.headers.get('content-type');
    if (contentType.search(/application\/(vnd.siren\+)?json/) !== -1) {
      const json = await response.json();
      flash.add(json.error, 'critical');
    } else {
      const text = await response.text();
      flash.add(text, 'critical');
    }
  }
});

ship.on('success', () => {
  loadingBar.style.backgroundColor = 'var(--green-base)';
});

ship.on('complete', () => {
  loadingBar.style.width = '100%';
});

ship.on('update', async function(e) {
  const { entity } = e.detail;

  console.log('update', entity)

  if (!entity)
    return;

  const self = entity.getLink('self');
  if (self) {
    const href = self.href.replace(ship.baseUri, '');
    location.hash = href;
    currentPath = href;
  }
  document.body.scrollTop = document.documentElement.scrollTop = 0;

  const { token } = entity.properties;
  if (token && token !== ship.token) {
    ship.token = token;
    makeRequest();
    flash.add('Token updated.', 'success');
  }

  const profile = entity.getLink('profile');
  if (profile) {
    // fetch profile
    try {
      const response = await fetch(profile.href);
      const content = await response.text();
      const type = response.headers.get('content-type');
      const markup = type === 'text/markdown' ? marked(content) : content;
      profileContent.innerHTML = markup;
    }
    catch (err) {
      flash.add('Error fetching profile', 'critical');
      console.error(err);
    }
  } else {
    profileContent.innerHTML = 'No additional information to display.';
  }
});

// submit API reqest
let active = false;
const makeRequest = async function () {
  // one request at a time
  if (active) {
    return;
  }
  active = true;
  try {
    ship.baseUri = ship.baseUri;
    await ship.fetch(currentPath);
  } catch (err) {
    flash.add('Error with request.', 'critical');
    console.error(err); // eslint-disable-line no-console
  }
  active = false;
};

// clear auth token and reload
const clearToken = async function () {
  flash.clear();
  ship.token = undefined;
  currentPath = '';
  makeRequest();
};
document.getElementById('clear-token-button').addEventListener('click', clearToken);

const getStore = (key, def) => {
  const val = localStorage.getItem(key);
  return val === null ? def : JSON.parse(val);
}

// profile
const setShowProfile = async function() {
  profileContent.parentNode.style.display = this.checked ? 'block' : 'none';
  localStorage.setItem('show-profile', this.checked);
}
const profileToggle = document.getElementById('profile-toggle');
profileToggle.checked = getStore('show-profile', true);
profileToggle.addEventListener('change', setShowProfile);
profileToggle.dispatchEvent(new Event('change'));

// sync the location hash with the api href input field
const _checkHash = function () {
  const hash = location.hash.slice(1);
  if (currentPath === hash) {
    return;
  }
  currentPath = hash;
  makeRequest();
};

window.addEventListener('hashchange', _checkHash);
window.addEventListener('load', _checkHash);
